import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'count-cell',
  standalone: true,
  template: `
    <span class="cell-text" (click)="onCellClick(rowData)">{{
      rowData.updateCount
    }}</span>
  `,
  styles: [
    `
      .cell-text {
        font-family: var(--manrope);
        font-weight: 600;
        font-size: 16px;
        color: var(--brand-primary);
        cursor: pointer;
      }
    `,
  ],
})
export class CountCellComponent {
  @Input() rowData: any;
  @Output() cellClick: EventEmitter<any> = new EventEmitter<any>();
  onCellClick(rowData: any) {
    rowData = { ...rowData, count: true };
    console.log(rowData);
    this.cellClick.emit(rowData);
  }
}
